import { useAuth } from 'context'
import { FeatureGrant } from 'types'

type IUseAuthorizedFeature = {
  (feature: FeatureGrant): boolean
  (feature: FeatureGrant[]): boolean[]
}

/**
 * Convenience hook for checking if the current admin is authorized to use a specific feature
 *
 * @param feature The FeatureGrant or array of features to check
 * @returns true if authorized; otherwise false
 */
export const useAuthorizedFeature: IUseAuthorizedFeature = (feature: unknown): any => {
  const { isAuthorized } = useAuth()

  if (feature instanceof Array) {
    return (feature as FeatureGrant[]).map(isAuthorized)
  }
  return isAuthorized(feature as FeatureGrant)
}
